import { useState } from "react";
import { XIcon } from "lucide-react";

import { Badge } from "components/ui/badge";

export function ListFilter({ value, onChange }) {
  const values = value ?? [];
  const [draft, setDraft] = useState("");

  const addValue = () => {
    const next = draft.trim();
    if (next && !values.includes(next)) {
      onChange([...values, next]);
    }
    setDraft("");
  };

  const removeValue = target => onChange(values.filter(v => v !== target));

  const handleKeyDown = e => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addValue();
    } else if (e.key === "Backspace" && !draft && values.length) {
      removeValue(values[values.length - 1]);
    }
  };

  return (
    <div className="tw:flex tw:min-h-8 tw:w-full tw:flex-wrap tw:items-center tw:gap-1 tw:rounded-lg tw:border tw:border-input tw:bg-white tw:px-2 tw:py-1 tw:focus-within:border-ring tw:focus-within:ring-3 tw:focus-within:ring-ring/50 tw:dark:bg-background">
      {values.map(v => (
        <Badge key={v} variant="secondary" className="tw:gap-1">
          {v}
          <button
            type="button"
            aria-label={`Remove ${v}`}
            onClick={() => removeValue(v)}
            className="tw:opacity-60 tw:hover:opacity-100"
          >
            <XIcon className="tw:size-3" />
          </button>
        </Badge>
      ))}
      <input
        value={draft}
        onChange={e => setDraft(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={addValue}
        placeholder={values.length ? "" : "Type and press Enter"}
        className="tw:min-w-16 tw:flex-1 tw:bg-transparent tw:text-sm tw:outline-none"
      />
    </div>
  );
}
